import React from 'react';
import ImageUpload from '../ImageUpload';

const HeroAdmin = ({ siteData, updateSiteData, setSiteData, showSaveStatus }) => {
    const handleHeroUpdate = async (field, value) => {
        try {
            const updatedHero = {
                ...siteData.hero,
                [field]: value
            };

            // Update local state immediately
            setSiteData(prev => ({
                ...prev,
                hero: updatedHero
            }));

            // Save to Firestore
            await updateSiteData('hero', updatedHero);
            showSaveStatus('Hero section updated successfully!');
        } catch (error) {
            console.error('Failed to update hero:', error);
            showSaveStatus('Failed to update hero section', true);
        }
    };

    const handleImageUpload = async (field, pathField, imageUrl, imagePath) => {
        try {
            // Update both image URL and path
            const updatedHero = {
                ...siteData.hero,
                [field]: imageUrl,
                [pathField]: imagePath
            };

            setSiteData(prev => ({
                ...prev,
                hero: updatedHero
            }));

            await updateSiteData('hero', updatedHero);
            showSaveStatus('Hero image updated successfully!');
        } catch (error) {
            console.error('Failed to update hero image:', error);
            showSaveStatus('Failed to update hero image', true);
        }
    };

    return (
        <div className="space-y-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Hero Section</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Title</label>
                    <input
                        type="text"
                        value={siteData.hero.title || ''}
                        onChange={(e) => handleHeroUpdate('title', e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sage-500 focus:border-transparent"
                        placeholder="Savana Ashlea"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Subtitle</label>
                    <input
                        type="text"
                        value={siteData.hero.subtitle || ''}
                        onChange={(e) => handleHeroUpdate('subtitle', e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sage-500 focus:border-transparent"
                        placeholder="Artist • Photographer • Yoga Instructor"
                    />
                </div>
            </div>

            <div className="space-y-6">
                <h3 className="text-lg font-medium text-gray-900">Background Media</h3>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Background Image</label>
                    <ImageUpload
                        currentImage={siteData.hero.backgroundImage}
                        currentImagePath={siteData.hero.backgroundImagePath}
                        onImageUpload={(imageUrl, imagePath) =>
                            handleImageUpload('backgroundImage', 'backgroundImagePath', imageUrl, imagePath)
                        }
                        label="Upload Hero Background"
                        folder="hero"
                        aspectRatio={16 / 9}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Background Video URL (optional)</label>
                    <input
                        type="url"
                        value={siteData.hero.backgroundVideo || ''}
                        onChange={(e) => handleHeroUpdate('backgroundVideo', e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sage-500 focus:border-transparent"
                        placeholder="https://example.com/video.mp4"
                    />
                    <p className="text-xs text-gray-500 mt-1">Video will override background image if provided</p>
                </div>
            </div>

            {/* Preview */}
            <div className="border-t pt-6">
                <h3 className="text-lg font-medium text-gray-900 mb-4">Preview</h3>
                <div className="relative h-64 bg-gray-900 rounded-lg overflow-hidden">
                    {siteData.hero.backgroundImage && (
                        <img
                            src={siteData.hero.backgroundImage}
                            alt="Hero Preview"
                            className="w-full h-full object-cover"
                            onError={(e) => {
                                console.error('Failed to load preview image:', e);
                            }}
                        />
                    )}
                    <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
                        <div className="text-center text-white">
                            <h1 className="text-3xl font-light mb-2">{siteData.hero.title || 'Your Title'}</h1>
                            <p className="text-lg opacity-90">{siteData.hero.subtitle || 'Your Subtitle'}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroAdmin;